import { gql } from "@apollo/client";

const GET_HONORARIOS_VISITA = gql`
query GetHonorariosVistia($idVisita: Int!) {
    honorariosVisita(idVisita: $idVisita) {
        viatico
        valor
        virutal
        cambioSonda
        capacitacion
        extra
        emergencia
        extraduracion
        idTramoNavigation {
            valor
        }
    }
}`;

export default GET_HONORARIOS_VISITA;

export const adaptHonorariosVisita = (data) => {
  if (!data) return {};
  return {
    honorarioPresencial: data.honorariosVisita?.valor || 0,
    honorarioVirtual: data.honorariosVisita?.virutal || 0,
    cambioSonda: data.honorariosVisita?.cambioSonda || 0,
    capacitacion: data.honorariosVisita?.capacitacion || 0,
    emergencia: data.honorariosVisita?.emergencia || 0,
    extraDuracion: data.honorariosVisita?.extraduracion || 0,
    tramo: data.honorariosVisita?.viatico || 0,
    total: 0
  };
};